import React, { useEffect, useState } from "react";
import commonStyles from "../../../Components/Shared/commonStyles.module.css";
import styles from "./FAQ.module.css";
import CollapseModern from "../../../Components/Shared/Collapsable/CollapseModern";
import useFAQStore from "../../../Stores/useFAQStore";
import FAQMostAsked from "../../../Components/CustomerServices/FAQs/FAQMostAsked";
import Parser from "../../../Components/Shared/LinkParsing/Parser";
import CallToAction from "../../../Components/Shared/CallToAction/CallToAction";

function FAQ() {
  const { getFAQs, faqs, loading } = useFAQStore();

  useEffect(() => {
    const fetchFAQs = async () => {
      await getFAQs();
    };
    if (faqs.length === 0) {
      fetchFAQs();
    }
  }, []);

  return (
    <>
      <div className={commonStyles.section}>
        <div className={commonStyles.container}>
          <div className={commonStyles.sectionHeaderContainer}>
            <h2 className={commonStyles.sectionHeader}>
              Your Questions, Answered.
            </h2>
            <p className={commonStyles.paragraph}>
              We’ve gathered answers to the most common questions about our
              hampers, gifts, and services to make your shopping experience as
              smooth as possible. Can’t find what you’re looking for? Get in
              touch — we’re here to help.
            </p>
          </div>
        </div>
      </div>

      <div className={`${styles.faqContainer}`}>
        <div className={commonStyles.section}>
          <div className={commonStyles.container}>
            <div>
              <h3 className={commonStyles.eyebrow}>MOST ASKED QUESTIONS</h3>
            </div>
            <ul>
              <li>
                <FAQMostAsked
                  question="Are you local?"
                  answer="Yes! Match Hampers is proudly based in Jersey."
                />
              </li>
              <li>
                <FAQMostAsked
                  question="Do you have a shop?"
                  answer={
                    <Parser text="We don’t have a permanent shop, but you can see and purchase our gifts at [pop-up events](/Customer-Services/Popups)." />
                  }
                />
              </li>
              <li>
                <FAQMostAsked
                  question="Can I pay by card?"
                  answer="Yes, we accept all major cards, BACS, and cash."
                />
              </li>
              <li>
                <FAQMostAsked
                  question="Can I order online?"
                  answer={
                    <Parser text="Browse our full range and [contact us](/Customer-Services/Contact) via email or WhatsApp. You can also order in person at a [pop-up event](/Customer-Services/Popups)." />
                  }
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={commonStyles.section}>
        <div className={commonStyles.container}>
          <div className={styles.FaqSections}>
            {faqs.map((faqSection, index) => (
              <CollapseModern key={index} title={faqSection.Title}>
                <div className={commonStyles.cards4}>
                  {faqSection.FAQs.map((faq, faqIndex) => (
                    <div key={faqIndex} className={commonStyles.card}>
                      <b>{faq.Question}</b>
                      <p>
                        <Parser text={faq.Answer} />
                      </p>
                    </div>
                  ))}
                </div>
              </CollapseModern>
            ))}
          </div>
        </div>
      </div>

      <CallToAction />
    </>
  );
}

export default FAQ;
